export const PlantDesignDesignerVerifierPage = {
  areYouDesignerLabel: 'Are you the designer?',
  areYouDesignerHelpMessage: 'If you are the designer, we will add your details to this section.',

  personDetails: {
    firstNameLabel: 'First name',
    middleNameLabel: 'Middle name(s) (optional)',
    lastNameLabel: 'Last name',
    businessLabel: 'Business or employer (optional)',
  },
};
